import type { PredictionContract } from '@/services/prediction/types'

import { ActivePriceCellShell, LockedPriceCell } from '../_shared/RedesignedPriceCellShell'
import { formatPercentage } from '../utils/formatPercentage'

interface YesNoPriceCellProps {
  contract: PredictionContract
  /** 全卡最宽价格文本 —— 所有格统一宽度预留。 */
  sizingLabel?: string
  onContractClick?: (contract: PredictionContract) => void
}

/**
 * Port of cdc-web `FutureCard/YesNoPriceCell.tsx`，裁剪为 percentage-only：
 * 本区无 odds 格式切换（决策 7e），percentage 布局每行只有一格 Yes/buy
 * 价格（`formatPercentage(contract.yes)`）；无路由，点击只透传 stub 回调。
 *
 * 无报价（`!chance`）→ LockedPriceCell（禁用、无链接），与 cdc-web 一致。
 */
export function YesNoPriceCell({
  contract,
  sizingLabel,
  onContractClick,
}: Readonly<YesNoPriceCellProps>) {
  if (!contract.chance) {
    return <LockedPriceCell sizingLabel={sizingLabel} />
  }

  return (
    <ActivePriceCellShell
      label={formatPercentage(contract.yes)}
      sizingLabel={sizingLabel}
      onClick={
        onContractClick
          ? e => {
              e.stopPropagation()
              onContractClick(contract)
            }
          : undefined
      }
    />
  )
}
